import React, { useState } from 'react';
import {Link} from "react-router-dom";

const Nav = () => {
    const [active,setActive] = useState('Home')
    return (
        <div className="main-menu text-center ">
            <nav>
                <div className="main-menu__list">
                    <li >
                        <Link style={{textDecoration:'none'}}  to={process.env.PUBLIC_URL + `/`}> <div style={{color:active ===  'Home' ?  'black' : 'black'}}>Home</div> </Link>
                       
                        {/* <ul>
                            <li><Link to={process.env.PUBLIC_URL + `/`}>Home One</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/home-two`}>Home Two</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/home-three`}>Home Three</Link></li>
                            <li className="dropdown">
                                <Link to={process.env.PUBLIC_URL + `/`}>Header Styles</Link>
                                <ul>
                                    <li><Link to={process.env.PUBLIC_URL + `/`}>Header One</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + `/home-two`}>Header Two</Link></li>
                                    <li><Link to={process.env.PUBLIC_URL + `/home-three`}>Header Three</Link></li>
                                </ul>
                            </li>
                        </ul> */}


                    </li>
                    <li onClick={()=> setActive('About')} style={active === "About" ? {color: '#ff6f0f'}:{color:'black'}} ><Link style={{textDecoration:'none'}}   to={process.env.PUBLIC_URL + `/about`}><div style={active === "About" ? {color: '#ff6f0f'}:{color:'black'}}>About</div></Link></li>
                    {/* <li className="dropdown">
                        <Link to={process.env.PUBLIC_URL + `#`}>Pages</Link>
                        <ul>
                            <li><Link to={process.env.PUBLIC_URL + `/team`}>Team</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/team-details`}>Team Details</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/projects`}>Projects</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/project-details`}>Project Details</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/testimonials`}>Testimonial</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/gallery`}>Gallery</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/error`}>404 Error</Link></li>
                        </ul>
                    </li>
                    <li className="dropdown">
                        <Link to={process.env.PUBLIC_URL + `#`}>Donation</Link>
                        <ul>
                            <li><Link to={process.env.PUBLIC_URL + `/donation`}>Donation</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/donation-list`}>Donation List</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/donation-details`}>Donation Details</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/donate-now`}>Donate Now</Link></li>
                        </ul>
                    </li> */}
                    <li><Link style={{textDecoration:'none'}} to={process.env.PUBLIC_URL + `/Archive`}><div style={{color:active ===  'Archive' ?  '#ff6f0f' : 'black'}}>Archive</div></Link></li>
                   
                    {/* <li className="dropdown">
                        <Link to={process.env.PUBLIC_URL + `#`}>Blog</Link>
                        <ul>
                            <li><Link to={process.env.PUBLIC_URL + `/blog-v-1`}>Blog V-1</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/blog-v-2`}>Blog V-2</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/blog-sidebar`}>Blog Sidebar</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + `/blog-details`}>Blog Details</Link></li>
                        </ul>
                    </li> */
                    }

                    <li><Link style={{textDecoration:'none'}} to={process.env.PUBLIC_URL + `/contact`}><div style={{color:active ===  'Contact' ?  '#ff6f0f' : 'black'}}>Contact </div></Link></li>
                </div>
            </nav>

        
        </div>
    )
}

export default Nav;


